import TicketsCategoryEdit from "../Views/TicketsCategory/TicketsCategoryEdit.vue";
import TicketsCategoryCreate from "../Views/TicketsCategory/TicketsCategoryCreate.vue";
import TicketsCategoryList from "../Views/TicketsCategory/TicketsCategoryList.vue";
import {MODULES} from "../Constants/modules.js";

export const ticketCategoryRoutes = [
    {
        path: "/tickets-categories/edit/:id",
        name: "tickets-categories.edit",
        component: TicketsCategoryEdit,
        meta: {
                module: MODULES.TICKETS,
            menu: {
                parent: 'tickets',
                child: 'tickets-categories'
            },
            breadcrumb: {
                title: "Catégories de ticket",
                nav: {
                    all: {
                        active: "Modification",
                        inactive: [{
                            title: "Toutes les catégories",
                            link: {name: 'tickets-categories.list'}
                        }]
                    }
                }
            }
        },
    },
    {
        path: "/tickets-categories/create",
        name: "tickets-categories.create",
        component: TicketsCategoryCreate,
        meta: {
                module: MODULES.TICKETS,
            menu: {
                parent: 'tickets',
                child: 'tickets-categories'
            },
            breadcrumb: {
                title: "Catégories de ticket",
                nav: {
                    all: {
                        active: "Création",
                        inactive: [{
                            title: "Toutes les catégories",
                            link: {name: 'tickets-categories.list'}
                        }]
                    }
                }
            }
        },
    },
    {
        path: "/tickets-categories",
        name: "tickets-categories.list",
        component: TicketsCategoryList,
        meta: {
                module: MODULES.TICKETS,
            menu: {
                parent: 'tickets',
                child: 'tickets-categories'
            },
            breadcrumb: {
                title: "Catégories de ticket",
                nav: {
                    all: {
                        active: "Toutes les catégories",
                        inactive: []
                    }
                }
            }
        },
    }
];
